import type { ReactNode } from 'react';
import SV from 'server-vars';

import { contactDealerModalTypes as MODAL_TYPES } from '../helpers/constants';
import {
    contactDealerTitle,
    makeOfferContactTitle,
    contactDealerSubtitle,
    requestImagesTitle,
    requestCustomizationTitle,
    stringMessages,
    requestDyoCustomizationTitle,
    requestDyoCustomizationSubtitle,
} from '../messages/contactDealerMessages';
import { MessageDescriptor } from 'dibs-react-intl';

import type { AbTestV2 } from '../../server/types/dblRouteHandlerArgs';

export const getModalTitle = ({
    currentModal,
    showMakeOfferContact,
}: {
    currentModal: string;
    showMakeOfferContact: boolean;
}): ReactNode => {
    let modalTitle = showMakeOfferContact ? makeOfferContactTitle : contactDealerTitle;

    switch (currentModal) {
        case MODAL_TYPES.REQUEST_CUSTOMIZATION: {
            modalTitle = requestCustomizationTitle;
            break;
        }
        case MODAL_TYPES.REQUEST_IMAGES: {
            modalTitle = requestImagesTitle;
            break;
        }
        case MODAL_TYPES.DESIGN_YOUR_OWN: {
            modalTitle = requestDyoCustomizationTitle;
            break;
        }
        default: {
            break;
        }
    }
    return modalTitle;
};

export const getModalSubtitle = ({
    currentModal,
    showMakeOfferContact,
}: {
    currentModal: string;
    showMakeOfferContact: boolean;
}): ReactNode => {
    let modalSubtitle = null;
    if (showMakeOfferContact) {
        modalSubtitle = contactDealerSubtitle;
    } else if (currentModal === MODAL_TYPES.DESIGN_YOUR_OWN) {
        modalSubtitle = requestDyoCustomizationSubtitle;
    }
    return modalSubtitle;
};

export const getInitialMessage = (currentModal: string): MessageDescriptor | null => {
    if (currentModal === MODAL_TYPES.REQUEST_IMAGES) {
        return stringMessages.requestImagesMessage;
    }
    if (currentModal === MODAL_TYPES.REQUEST_PRICE) {
        return stringMessages.requestPriceMessage;
    }
    return null;
};

export const getPlaceholderText = (currentModal: string): MessageDescriptor => {
    if (currentModal === MODAL_TYPES.REQUEST_CUSTOMIZATION) {
        return stringMessages.requestCustomizationsPlaceholder;
    }
    if (currentModal === MODAL_TYPES.DESIGN_YOUR_OWN) {
        return stringMessages.requestDyoCustomizationsPlaceholder;
    }
    return stringMessages.messagePlaceholder;
};

export const OPOP_AB_TEST_NAME = 'OPOP-Messaging';
const getOPOPMessagingABTest = (): AbTestV2 | null => SV.get('abTestsV2')?.[OPOP_AB_TEST_NAME];
export const isOPOPMessagingABTest = (): boolean => !!getOPOPMessagingABTest()?.config?.isActive;
export const isControlOPOPMessagingABTest = (): boolean =>
    getOPOPMessagingABTest()?.variant === 'control';
export const isVariantOneMessagingABTest = (): boolean =>
    getOPOPMessagingABTest()?.variant === 'variant-1';
